var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import getSubdomainFromRule from 'src/imports/getSubdomainFromRule';
import Form from 'antd/lib/form';
import Input from 'antd/lib/input';
import 'antd/lib/input/style/index.css';
var InputSubdomain = (function (_super) {
    __extends(InputSubdomain, _super);
    function InputSubdomain(props) {
        var _this = _super.call(this, props) || this;
        _this.subdomainRegex = /^[A-Za-z0-9](?:[A-Za-z0-9\-_]{4,61})[A-Za-z0-9]$/;
        _this.state = {
            checkUnique: undefined,
        };
        _this.handleChangeValue = _this.handleChangeValue.bind(_this);
        _this.handleSubdomainCheck = _this.handleSubdomainCheck.bind(_this);
        return _this;
    }
    InputSubdomain.prototype.componentWillUnmount = function () {
        clearTimeout(this.timer);
    };
    InputSubdomain.prototype.handleChangeValue = function (e) {
        if (!e || !e.target) {
            return e;
        }
        var paymentTier = this.props.form.getFieldValue('paymentTier');
        var subdomain = getSubdomainFromRule(paymentTier, e.target.value);
        this.handleSubdomainCheck(subdomain);
        return e.target.value;
    };
    InputSubdomain.prototype.handleSubdomainCheck = function (subdomain) {
        var _this = this;
        clearTimeout(this.timer);
        if (subdomain.length === 0) {
            this.setState({
                checkUnique: undefined,
                checkUniqueError: undefined,
            });
            return;
        }
        if (subdomain.length < 6) {
            this.setState({
                checkUnique: 'error',
                checkUniqueError: 'Minimum of 6 characters',
            });
            return;
        }
        if (!this.subdomainRegex.test(subdomain)) {
            this.setState({
                checkUnique: 'error',
                checkUniqueError: 'Invalid address (alphabets, numbers, dashes and underscores only)',
            });
            return;
        }
        this.setState({
            checkUnique: 'validating',
            checkUniqueError: undefined,
        });
        this.timer = window.setTimeout(function () {
            _this.props.handleFindEvent(subdomain)
                .then(function (res) {
                if (res.value.total > 0) {
                    _this.setState({
                        checkUnique: 'error',
                        checkUniqueError: "\"" + subdomain + ".crimp.rocks\" has been taken",
                    });
                }
                else {
                    _this.setState({
                        checkUnique: 'success',
                    });
                }
            })
                .catch(function (err) {
                _this.setState({
                    checkUnique: 'error',
                    checkUniqueError: err.message,
                });
            });
        }, 300);
    };
    InputSubdomain.prototype.render = function () {
        var _this = this;
        var paymentTier = this.props.form.getFieldValue('paymentTier');
        var isPaidTier = paymentTier && paymentTier > 0;
        return (React.createElement(Form.Item, { label: 'CRIMP event address', extra: 'Your athletes will see their live scores on the website at this address', hasFeedback: this.state.checkUnique !== undefined, validateStatus: this.props.form.getFieldsError(['subdomain']).subdomain ? 'error' : this.state.checkUnique, help: this.state.checkUniqueError, className: 'formItemHasValidationWithSuffix', colon: false }, this.props.form.getFieldDecorator('subdomain', {
            initialValue: this.props.initialValue || '',
            rules: [{
                    required: true,
                    message: 'Please have a CRIMP address for your event',
                }, {
                    max: isPaidTier ? 63 : 58,
                    message: 'Web address is too long and will break the internet',
                }, {
                    min: isPaidTier ? 6 : 1,
                    message: 'Minimum of 6 characters',
                }, {
                    validator: function (rule, value, callback) {
                        var subdomain = getSubdomainFromRule(isPaidTier ? 1 : 0, value);
                        if (_this.subdomainRegex.test(subdomain)) {
                            callback();
                        }
                        else {
                            callback('Invalid address (alphabets, numbers, dashes and underscores only)');
                        }
                    },
                }, {
                    type: 'string',
                }, {
                    whitespace: true,
                }],
            getValueFromEvent: this.handleChangeValue,
        })(React.createElement(Input, { size: 'large', autoComplete: 'off', disabled: this.props.isDisabled, addonBefore: isPaidTier ? 'https://' : 'https://free-', addonAfter: React.createElement("span", { style: { paddingRight: 15 } }, ".crimp.rocks") }))));
    };
    return InputSubdomain;
}(React.Component));
export default InputSubdomain;



//////////////////
// WEBPACK FOOTER
// ./src/pages/WorkspaceEvent/FormEventPage/FormEvent/InputSubdomain.tsx
// module id = 1158
// module chunks = 0